/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-biddingOppo',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '行业大类',
            value: 'industryCategoryList',
            type: 'select',
            options: [],
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '行业类型',
            value: 'industryTypeName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'industryTypeName', 'value': '行业类型名称' },
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' }
            ],
            tableConfig: [
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' },
                { 'prop': 'industryTypeName', 'value': '行业类型名称', 'displayName': 'industryTypeName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/industry/info/page`,
            method: 'post',
            cbParams: ['industryTypeCode', 'industryTypeName']
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName']
        },
        {
            name: '商机大类',
            value: 'opportunityCategoryList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_BUSINESS_TYPE',
            span: 5
        },
        {
            name: '商机状态',
            value: 'opportunityStatusList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_OPPORTUNITY_STATUS',
            span: 5
        }
    ],
    columns: [
        {
            label: '商机名称',
            prop: 'opportunityName',
            width: 200
        },
        {
            label: '商机状态',
            prop: 'opportunityStatus',
            width: 100,
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_OPPORTUNITY_STATUS'
        },
        {
            label: '行业大类',
            prop: 'industryCategoriesName',
            width: 120
        },
        {
            label: '行业类型',
            prop: 'industryTypeName',
            width: 120
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 230
        },
        {
            label: '商机编码',
            width: 150,
            prop: 'opportunityCode'
        },
        {
            label: '客户系',
            width: 150,
            prop: 'customerSeriesName'
        },
        {
            label: '分公司',
            width: 150,
            prop: 'branchCompany'
        },
        {
            label: '地级市',
            width: 150,
            prop: 'city'
        },
        {
            label: '始发仓',
            width: 150,
            type: 'slot',
            slot: true,
            editSlot: true,
            prop: 'warehouseType',
            optionsKey: 'NEOCRM_WH_TYPE'
        },
        {
            label: '商机大类',
            width: 150,
            type: 'slot',
            slot: true,
            editSlot: true,
            prop: 'opportunityCategory',
            optionsKey: 'NEOCRM_BUSINESS_TYPE'
        },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
